<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    active?: boolean
    url?: string
  }>(),
  {
    active: false,
    url: '',
  },
)

const active = computed(() => props.active)
</script>

<template>
  <ButtonBase :to="url" :class="['variant', 'label', { active }]">
    <slot />
  </ButtonBase>
</template>
<style scoped lang="scss">
.variant {
  --color-background: var(--c-background-medium);

  @include fluid-ts-ds(--pv, 12px, 16px);
  @include fluid-ts-ds(--ph, 16px, 24px);

  &:not(.active) {
    --color-background-hover: var(--c-secondary);
  }

  :deep(.background) {
    border: none;
    transform: none !important;
    @include fluid-ts-ds(border-radius, 6px, 8px);
  }

  :deep(svg) {
    --icon-size: 24px;
  }

  &.active {
    --color: var(--c-white);
    --color-background: var(--c-primary);
    --color-background-hover: var(--c-blue-rollover);
    --color-hover: var(--c-white);
  }
}
</style>
